import { useState } from "react";

import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { ModalConfirm, ModalInstance } from "@js/components/modal";
import { Snackbar } from "@js/components/snackbar";

import { useMarkBidAsHiredMutation } from "../../api";

type OpenMarkAsHiredConfirmationModalProps = {
  bidId: number;
};

const MarkAsHiredConfirmationModalContent = ({
  bidId,
}: OpenMarkAsHiredConfirmationModalProps) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const [markBidAsHired, { isLoading }] = useMarkBidAsHiredMutation();

  const handleConfirm = () => {
    if (isConfirming || isLoading) return;

    setIsConfirming(true);

    markBidAsHired({ bidId })
      .unwrap()
      .then(() => {
        Snackbar.success("Bid marked as hired.");
      })
      .catch(() => {
        Snackbar.error("Something went wrong.");
      })
      .finally(() => {
        ModalInstance.close();
      });
  };

  return (
    <ModalConfirm
      confirmText="Confirm"
      confirmDisabled={isConfirming}
      onConfirm={handleConfirm}
      onCancel={() => ModalInstance.close()}
    >
      <Typography component="h1" variant="title" fontWeight={400} size="small">
        Mark as Hired
      </Typography>
      <Box sx={{ pr: 6, mt: 1 }}>
        Are you sure you want to mark this application as hired?
      </Box>
    </ModalConfirm>
  );
};

export const openMarkAsHiredConfirmationModal = (
  props: OpenMarkAsHiredConfirmationModalProps,
) => {
  ModalInstance.open({
    children: <MarkAsHiredConfirmationModalContent {...props} />,
  });
};
